import React, { useEffect } from "react";

export const handleExpand = ({ target }: { target: EventTarget }) => {
  // @ts-ignore
  var blurb = target.querySelector(".itf-tour__link-description");
  var container = document.querySelector(".itf-tour__blurb-text");
  var blurbContainer = document.querySelector(".itf-tour__blurb-container");
  var menuBtn = document.querySelector(".itf-tour__mobile-menu-btn");
  var menuContainer = document.querySelector(
    ".itf-tour__mobile-menu-container"
  );

  let delay =
    menuBtn &&
    target &&
    !!menuBtn.classList.contains("open") &&
    // @ts-ignore
    !!!target.classList.contains("open")
      ? 500
      : 0;

  if (menuBtn) {
    menuBtn.classList.remove("open");
  }

  if (menuContainer) {
    menuContainer.classList.remove("open");
  }

  setTimeout(() => {
    // @ts-ignore
    target.classList.toggle("open");
    if (blurbContainer && target) {
      blurbContainer.classList.toggle("open");
    }
  }, delay);

  if (blurb && container) {
    container.innerHTML = blurb.innerHTML;
  }
};

export const CircuitLandingInit = () => {
  const navLinks: HTMLElement[] | null = Array.from(
    document.querySelectorAll(".itf-tour__link a")
  );

  navLinks.forEach((link: HTMLElement) => {
    link.classList.add(
      `btn--${link.innerHTML}`.toLowerCase().replace(/ /g, "-")
    );
    // @ts-ignore
    link.parentElement.classList.add(
      `btn--${link.innerHTML}`.toLowerCase().replace(/ /g, "-")
    );
  });

  // @ts-ignore
  const mobileMenuLink: HTMLElement[] | null = Array.from(
    document.querySelectorAll(".itf-tour__link")
  ).filter(
    (el: HTMLElement) =>
      !el.classList.contains("expandable") &&
      !el.classList.contains("btn--live") &&
      !el.classList.contains("btn--live-scores")
  );

  let mobileMenuHTML = "";

  if (mobileMenuLink && mobileMenuLink.length) {
    mobileMenuLink.forEach(el => {
      mobileMenuHTML += el.outerHTML;
    });

    let div = document.createElement("div");
    div.className = "itf-tour__mobile-menu";
    div.innerHTML = `<span class='itf-tour__mobile-menu-btn'></span>
      <div class='itf-tour__mobile-menu-container'>
        <ul>
          ${mobileMenuHTML}
        </ul>
      </div>
      `;
    // @ts-ignore
    document.querySelector(".itf-tour").appendChild(div);
    // @ts-ignore
    document
      .querySelector(".itf-tour__mobile-menu-btn")
      .addEventListener("click", ({ target }) => {
        let delay =
          target &&
          // @ts-ignore
          !!document
            .querySelector(".itf-tour__blurb-container")
            .classList.contains("open") &&
          // @ts-ignore
          !!!target.classList.contains("open")
            ? 500
            : 0;

        // @ts-ignore
        target.classList.toggle("open");
        setTimeout(() => {
          // @ts-ignore
          document
            .querySelector(".itf-tour__mobile-menu-container")
            .classList.toggle("open");
        }, delay);
        // @ts-ignore
        document
          .querySelector(".itf-tour__blurb-container")
          .classList.remove("open");
        Array.from(document.querySelectorAll(".itf-tour__link")).forEach(el => {
          el.classList.remove("open");
        });
      });
  }
};

export default ({ title = "Passion To Play.", logo = "", subtitle = "" }) => {
  useEffect(() => {
    CircuitLandingInit();
  });
  const brand = logo.length ? { backgroundImage: `url(${logo})` } : {};
  const styles = { ...brand };
  return (
    <div className={`itf-tour`}>
      <main className="container">
        <div className="itf-tour__nav">
          <div className="itf-tour__header-wrapper">
            <span
              className="sponsor"
              style={{
                backgroundImage: `url(https://qa-www.itftennis.com/media/6543/uniqlo-logo-rgb.png)`
              }}
            />
            <div className="itf-tour__branding-wrapper">
              <div className="itf-tour__branding">
                <h2 className="itf-tour__heading branded">
                  <span style={styles} />
                  <div>{title}</div>
                  <span
                    className="sponsor"
                    style={{
                      backgroundImage: `url(https://qa-www.itftennis.com/media/6543/uniqlo-logo-rgb.png)`
                    }}
                  />
                </h2>
              </div>
              {subtitle ? (
                <div className="itf-tour__subheading">{subtitle}</div>
              ) : null}
            </div>
          </div>
          <ul className="itf-tour__links desktop">
            <li onClick={handleExpand} className="itf-tour__link expandable">
              <div className="itf-tour__link-description">
                Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                Laborum autem odit velit nesciunt eius, impedit quod, ducimus
                laboriosam quaerat iure voluptates fugit rem voluptatum
                accusamus, magnam sequi consectetur? Corporis, tempore? Lorem
                ipsum dolor sit, amet consectetur adipisicing elit. Laborum
                autem odit velit nesciunt eius, impedit quod, ducimus laboriosam
                quaerat iure voluptates fugit rem voluptatum accusamus, magnam
                sequi consectetur? Corporis, tempore? Lorem ipsum dolor sit,
                amet consectetur adipisicing elit. Laborum autem odit velit
                nesciunt eius, impedit quod, ducimus laboriosam quaerat iure
                voluptates fugit rem voluptatum accusamus, magnam sequi
                consectetur? Corporis, tempore?
              </div>
              About the tour
            </li>
            <li className="itf-tour__link">
              <a href="#">Calendar</a>
            </li>
            <li className="itf-tour__link">
              <a href="#latest-tournaments">Latest results</a>
            </li>
            <li className="itf-tour__link">
              <a href="#">Rankings</a>
            </li>
            <li className="itf-tour__link">
              <a href="#">Mens</a>
            </li>
            <li className="itf-tour__link btn--live">
              <a href="#">Live Scores</a>
            </li>
          </ul>
        </div>
      </main>
      <div className="itf-tour__blurb-container container">
        <div className="itf-tour__blurb-text"></div>
      </div>
    </div>
  );
};
